import cloneDeep from 'lodash/cloneDeep';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setRuleHaveEditting } from '../../../../../../actions/common';
import { callSalesforceApi, callTokenApi } from '../../../../../../apiCaller';
import { API_CLIENT_DIMENSION_DETAIL, API_CLIENT_GET_ALL_CONVERSION, API_CLIENT_GET_SALES_CONVERSION, API_SS_TRIGGER_GET_CUSTOM_OBJECT, DIMENSION_CRM_SCOPED, SECTION_REPORT, TYPE_SHOW_UNSAVE_CHANGE } from '../../../../../../constants';
import CenterSpinner from '../../../../../general/Loadings/CenterSpinner';
import { toastError } from '../../../../../../utils';
import { toast } from 'react-toastify';

const Step1 = React.lazy(() => import(`./steps/Step1`));
const Step2 = React.lazy(() => import('./steps/Step2'));
const Step3 = React.lazy(() => import('./steps/Step3'));
const Step4 = React.lazy(() => import('./steps/Step4'));

export const CustomPropertiesDetailContext = React.createContext({});

const DEFAULT_DIMENSION_DATA = {
     dataSource: '',
     eventObjectName: '',
     pathPropertyName: '',
     availableScopes: [
          {
               isWebConversion: false,
               id: '',
               eventScopeId: '',
               objectConversion: '',
               getFromAllEvents: false,
               relatedName: '',
               conversionId: '',
               target: '',
          },
     ],
     name: '',
     description: '',
};

const CustomPropertiesDetails = ({ id }) => {
     const dispatch = useDispatch();
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const accountId = activeAccount.id;

     const externalObjectReport = useSelector((state) => state.subscriber.externalObjectReport);
     const customExternalObjectReport = useSelector((state) => (state.subscriber.customExternalObjectReport));
     const objectCharacteristicSF = externalObjectReport
          .filter(({ characteristicOtherObject }) => characteristicOtherObject)
          .map(({ object }) => {
               if (DIMENSION_CRM_SCOPED[object]) {
                    return { label: DIMENSION_CRM_SCOPED[object], value: DIMENSION_CRM_SCOPED[object] };
               }

               return { label: `CRM ${object}`, value: `${object}` };
          });

     const objectCharacteristicCustomEX = customExternalObjectReport
          .filter(({ characteristicOtherObject }) => characteristicOtherObject)
          .map(({ object, externalId, characteristicHasRevenue, characteristicIsCompany, characteristicIsPerson }) => {
               return { label: `${object}`, value: `${object}`, externalId, characteristicHasRevenue, characteristicIsCompany, characteristicIsPerson };
          });

     const customExtOtherFields = customExternalObjectReport
          .filter(({ characteristicOtherObject }) => characteristicOtherObject)
          .reduce((acc, { object, otherFields }) => {
               let otherFieldsData = (otherFields && otherFields[0]?.fields) || [];

               if (otherFieldsData.length > 0) {
                    const customOtherFields = (otherFieldsData?.filter((item) => item.type !== 'NUMERIC' || item.considerProperty)) || [];
                    otherFieldsData = customOtherFields.map((_) => ({
                         value: 'otherFields.' + _.name,
                         label: _.label,
                         section: SECTION_REPORT.OTHER_FIELDS,
                         type: _.type
                    }));
               }

               acc[object] = otherFieldsData || [];
               return acc;
          }, {});

     const [isLoading, setIsLoading] = useState(false);
     const [activeStep, setActiveStep] = useState(1);
     const [stepsData, setStepsData] = useState(cloneDeep(DEFAULT_DIMENSION_DATA));
     const [initStepsData, setInitStepsData] = useState(cloneDeep(DEFAULT_DIMENSION_DATA));
     const [optionConversion, setOptionConversion] = useState([]);
     const [dataCustomSSTrigger, setDataCustomSSTrigger] = useState([]);
     const [listCustomObjectFields, setListCustomObjectFields] = useState();
     const [listSalesConversion, setListSalesConversion] = useState({})

     const fetchDimensionDetail = () => {
          setIsLoading(true);
          callTokenApi(API_CLIENT_GET_ALL_CONVERSION.replace(':accountId', accountId), 'GET')
               .then((response) => {
                    if (response.status === 200) {
                         const { listConversion } = response.data;
                         setOptionConversion(listConversion);
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    if (!id) {
                         setIsLoading(false);
                    }
               });

          callTokenApi(API_CLIENT_GET_SALES_CONVERSION.replace(':accountId', accountId), 'GET')
          .then((response) => {
               if (response.status === 200) {
                    const { conversions } = response.data;
                    setListSalesConversion(conversions);
               } else {
                    toastError(response);
               }
          })
          .finally(() => {
               if (!id) {
                    setIsLoading(false);
               }
          });

          if (!id) return;

          callTokenApi(API_CLIENT_DIMENSION_DETAIL.replace(':accountId', accountId).replace(':id', id), 'GET')
               .then((response) => {
                    if (response.status === 200) {
                         const { dimension } = response.data;
                         dimension.propertyType = dimension.availableScopes && dimension.availableScopes[0] && dimension.availableScopes[0].propertyType;
                         setStepsData(dimension);
                         setInitStepsData(dimension);
                    } else {
                         toastError(response);
                    }
               })
               .finally(() => {
                    setIsLoading(false);
               });
     };
     useEffect(fetchDimensionDetail, []); // eslint-disable-line react-hooks/exhaustive-deps

     const fetchSSCustomObject = () => {
          const request = `${API_SS_TRIGGER_GET_CUSTOM_OBJECT}?accountId=${accountId}`;

          callSalesforceApi(request, 'GET').then((response) => {

               if (response?.status === 200) {
                    const { data } = response.data;

                    setDataCustomSSTrigger(data.objectData);
                    setListCustomObjectFields(data.customObjectFields);
               } else {
                    toast.error('Get data failed!');
               }
          });
     };

     useEffect(fetchSSCustomObject, []); // eslint-disable-line react-hooks/exhaustive-deps

     const handleHasChange = () => {
          dispatch(setRuleHaveEditting({ show: true, type: TYPE_SHOW_UNSAVE_CHANGE.EDIT_SIMPLE }));
     };

     return (
          <React.Suspense fallback={<CenterSpinner />}>
               <div className='rule-detail dimension-detail'>
                    {isLoading ? (
                         <CenterSpinner />
                    ) : (
                         <div className='cvr-create-new'>
                              <h1>{id ? `Edit Property: ${stepsData.name}` : `Create a Property`}</h1>
                              <p>{id ? 'Use the steps below to configure your property.' : 'Create your property by following the steps below. '} </p>
                              <CustomPropertiesDetailContext.Provider value={{ id, activeStep, setActiveStep, initStepsData, setInitStepsData, stepsData, setStepsData, handleHasChange, optionConversion, dataCustomSSTrigger, listCustomObjectFields, objectCharacteristicSF, objectCharacteristicCustomEX, customExtOtherFields, listSalesConversion }}>
                                   <Step1 />
                                   <Step2 />
                                   <Step3 />
                                   <Step4 />
                              </CustomPropertiesDetailContext.Provider>
                         </div>
                    )}
               </div>
          </React.Suspense>
     );
};

export default CustomPropertiesDetails;
